import React from "react";
import cn from "classnames";

import { FormElement } from "../shared-style";

import Label from "../Label";
import Validation from "../Validation";

import { IProps } from "./interfaces";
import { StyledInput } from "./styles";

const InputPassword = ({ label, value, onChange, name, validation, required, disabled }: IProps) => (
    <FormElement>
        <Label disabled={disabled} required={required}>
            {label}
        </Label>
        {validation && <Validation validation={validation} />}
        <StyledInput
            className={cn(validation && "ValidationState")}
            type="password"
            value={value}
            name={name}
            onChange={onChange}
            disabled={disabled}
        />
    </FormElement>
);

export default InputPassword;
